export default __webpack_public_path__ + "static/media/mirana.2a96d745.png";